import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './loading';

const reducers = combineReducers({
  loading: uiReducer,
});

export default reducers;
